import NotificationSubscriptionsAPI from '../../api/notificationSubscription';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isDeleting: false,
    isTesting: {},
  },
  testResults: {},
};

const getters = {
  getSubscriptions: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getTestResult: $state => id => $state.testResults[id],
  getFCMSubscriptions: $state =>
    $state.records.filter(
      subscription => subscription.subscription_type === 'fcm'
    ),
  getBrowserSubscriptions: $state =>
    $state.records.filter(
      subscription => subscription.subscription_type === 'browser_push'
    ),
  getStaleSubscriptions: $state =>
    $state.records.filter(subscription => subscription.stale),
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await NotificationSubscriptionsAPI.get();
      commit('SET_RECORDS', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await NotificationSubscriptionsAPI.delete(id);
      commit('REMOVE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async testPush({ commit }, id) {
    let subscriptionDeleted = false;

    commit('SET_TESTING', { id, testing: true });
    commit('SET_TEST_RESULT', { id, result: null });

    try {
      await NotificationSubscriptionsAPI.testPush(id);
      commit('SET_TEST_RESULT', { id, result: { success: true } });
    } catch (error) {
      subscriptionDeleted = Boolean(error.response?.data?.subscription_deleted);

      if (subscriptionDeleted) {
        commit('REMOVE_RECORD', id);
        return;
      }

      commit('SET_TEST_RESULT', {
        id,
        result: {
          success: false,
          error: error.response?.data?.error || error.message,
        },
      });
    } finally {
      if (!subscriptionDeleted) {
        commit('SET_TESTING', { id, testing: false });
      }
    }
  },
};

const mutations = {
  SET_RECORDS($state, records) {
    $state.records = records;
  },

  REMOVE_RECORD($state, id) {
    $state.records = $state.records.filter(record => record.id !== id);

    if ($state.testResults[id]) {
      const remainingResults = { ...$state.testResults };
      delete remainingResults[id];
      $state.testResults = remainingResults;
    }

    if ($state.uiFlags.isTesting[id] !== undefined) {
      const remainingFlags = { ...$state.uiFlags.isTesting };
      delete remainingFlags[id];
      $state.uiFlags.isTesting = remainingFlags;
    }
  },

  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },

  SET_TESTING($state, { id, testing }) {
    $state.uiFlags.isTesting = {
      ...$state.uiFlags.isTesting,
      [id]: testing,
    };
  },

  SET_TEST_RESULT($state, { id, result }) {
    $state.testResults = { ...$state.testResults, [id]: result };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
